import { AnyDocument, DocumentTransitionsResult } from '../../../types';
import { ConstructPost } from '../../types/ConstructPost';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { DOCUMENTS_BASE_PATH } from '../constants/documentsBasePath';
import { buildHeadersFromDocumentParams } from '../logic/buildHeadersFromDocumentParams';
import { DocumentParams } from '../types/DocumentParams';

export const updateDocumentTransition = async <
  Payload = Record<string, unknown>,
>(
  constructPost: ConstructPost,
  documentParams: DocumentParams,
  documentId: AnyDocument['id'],
  payload: Payload,
): Promise<NonPaginatedResponse<DocumentTransitionsResult> | undefined> =>
  constructPost<NonPaginatedResponse<DocumentTransitionsResult>>(
    `${DOCUMENTS_BASE_PATH}/${documentId}/transition`,
    {
      headers: buildHeadersFromDocumentParams(documentParams),
      data: payload,
    },
  );
